module.exports = __webpack_public_path__ + "static/media/trending2.252e2979.png";